import { render, staticRenderFns } from "./TikTokPostFilter.vue?vue&type=template&id=0b94a4db&scoped=true"
import script from "./TikTokPostFilter.vue?vue&type=script&lang=ts"
export * from "./TikTokPostFilter.vue?vue&type=script&lang=ts"
import style0 from "./TikTokPostFilter.vue?vue&type=style&index=0&id=0b94a4db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94a4db",
  null
  
)

export default component.exports